import type { UseMutateFunction } from '@tanstack/react-query';

import { onGoToManageDataCreditsPage } from '../externalLinks';
import { useNotifyAdminForQuotaMutation } from '../notifyAdmin/useNotifyAdminForQuotaMutation';

import { useNotifyAdminForQuotaSuccess } from './useNotifyAdminForQuotaSuccess';

type HookValue = {
  hasNotifiedAdmin: boolean;
  isNotifyingAdmin: boolean;
  onNotifyAdmin: UseMutateFunction<void>;
  onGoToManageDataCreditsPage: VoidFunction;
};

export const useQuotaActions = (): HookValue => {
  const { hasNotifiedAdmin, setHasNotifiedAdmin } = useNotifyAdminForQuotaSuccess();

  const { isPending, mutate } = useNotifyAdminForQuotaMutation(() => {
    setHasNotifiedAdmin(true);
  });

  return {
    hasNotifiedAdmin,
    isNotifyingAdmin: isPending,
    onNotifyAdmin: mutate,
    onGoToManageDataCreditsPage,
  };
};
